var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7048 51.7048C41.8192 54.4124 37.095 56 32 56C18.7452 56 8 45.2548 8 32C8 26.905 9.58764 22.1808 12.2952 18.2952L45.7048 51.7048ZM51.4194 46.1057L17.8943 12.5806C21.8539 9.69956 26.7285 8 32 8C45.2548 8 56 18.7452 56 32C56 37.2715 54.3004 42.1461 51.4194 46.1057ZM64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32Z",
    fill: "#1A2352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopicon);
export default __webpack_public_path__ + "static/media/STOP ICON.66e2507bff832c3d64bbdaa5f24b5cfb.svg";
export { ForwardRef as ReactComponent };